<template>
  <page-poster-with-image
    :headline="$t('referral.page.header', { reward: referralReward, class: 'blue' })"
    src="/img/posters/invitePoster.png"
    :alt="$t('referral')"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import PagePosterWithImage from '@/components/common/PagePosterWithImage.vue';

export default {
  components: {
    PagePosterWithImage,
  },
  computed: {
    ...mapGetters(['referralReward']),
  },
};
</script>